import type React from "react";
import styles from "./index.module.scss";

interface TopStickyProps {
  content: string;
}

export const TopSticky: React.FC<TopStickyProps> = ({ content }) => {
  return <span className={styles["stick-container"]}>{content}</span>;
};
